import { get } from 'lodash';
import dateTimeMixin from '@/mixins/date-time';

export default {
  name: 'ChartBasicMixin',
  mixins: [dateTimeMixin],
  methods: {
    getBasicChartOptions(seriesType) {
      if (!Array.isArray(this.chartData)) {
        return {};
      }

      const toolboxActions = get(this.widget, 'chartOptions.toolbox.actions', []);
      const showToolbox = toolboxActions.length > 0;

      let yAxisMin = get(this.widget, 'chartOptions.yAxisMin', 'auto');
      let yAxisMax = get(this.widget, 'chartOptions.yAxisMax', 'auto');

      if (yAxisMin === 'auto') {
        yAxisMin = undefined;
      } else if (yAxisMin === 'auto-cropped') {
        yAxisMin = 'dataMin';
      }

      if (yAxisMax === 'auto') {
        yAxisMax = undefined;
      } else if (yAxisMax === 'auto-cropped') {
        yAxisMax = 'dataMax';
      }

      const yAxisNameChartOptions = get(this.widget, 'chartOptions.yAxis.name', {});

      const yAxisNameOptions = {
        show: true,
        name: yAxisNameChartOptions.text || '',
        nameLocation: 'middle',
        nameGap: get(this.widget, 'chartOptions.yAxis.nameGap', 30),
        nameTextStyle: {
          fontSize: 18,
        },
      };

      return {
        tooltip: {
          axisPointer: {
            type: 'cross',
            label: {
              show: true,
              formatter: (item) => {
                if (item.axisDimension === 'x') {
                  return this.formatDateTime(item.value, get(this.widget, 'chartOptions.lineChart.dateTimeFormat'));
                }

                return item.value;
              },
            },
          },
        },
        legend: {
          type: 'scroll',
          orient: 'horizontal',
          right: 0,
          top: showToolbox ? 30 : 0,
          left: 0,
          data: this.chartData
            .map((twin) =>
              twin.states.map((state) => {
                return this.getStateLabel(twin, state.state);
              })
            )
            .flat(),
        },
        xAxis: {
          type: 'time',
          boundaryGap: false,
          axisLabel: {
            formatter: (value) => this.formatDateTime(value, get(this.widget, 'chartOptions.dateTimeFormat')),
            rotate: get(this.widget, 'chartOptions.xAxisRotation', 10),
          },
        },
        yAxis: {
          type: 'value',
          min: yAxisMin,
          max: yAxisMax,
          ...yAxisNameOptions,
        },
        grid: {
          top: showToolbox ? 70 : 40,
          left: `${get(this.widget, 'chartOptions.grid.left', 10)}%`,
          right: `${get(this.widget, 'chartOptions.grid.right', 0)}%`,
        },
        series: this.chartData
          .map((twin) =>
            twin.states
              .map((state) => ({
                name: this.getStateLabel(twin, state.state),
                type: seriesType,
                data: state.history.map((history) => [history.timestamp, history.value]),
                smooth: get(this.widget, 'chartOptions.lineChart.smooth', false),
              }))
              .flat()
          )
          .flat(),
      };
    },
  },
};
